import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { DownloadIcon, ZapIcon, ClockIcon } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    icon: <DownloadIcon className="w-8 h-8 text-coral" data-id="element-114" />,
    title: 'Descarga',
    desc: 'Descarga el manual e identifica tus disparadores de inflamación actuales.'
  }, {
    icon: <ZapIcon className="w-8 h-8 text-coral" data-id="element-115" />,
    title: 'Aplica',
    desc: 'Aplica el menú de 7 días diseñado para resetear tu cortisol e insulina.'
  }, {
    icon: <ClockIcon className="w-8 h-8 text-coral" data-id="element-116" />,
    title: 'Observa',
    desc: 'Observa cómo la deshinchazón ocurre de forma natural y recuperas tu energía vital.'
  }];
  return <SectionWrapper className="bg-white" data-id="element-117">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-16 text-charcoal" data-id="element-118">
        Cómo funciona
      </h2>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-119">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-coral-light -z-10" data-id="element-120"></div>

        {steps.map((step, index) => <div key={index} className="flex flex-col items-center text-center" data-id="element-121">
            <div className="w-24 h-24 bg-cream rounded-full flex items-center justify-center mb-6 shadow-sm border-4 border-white relative z-10" data-id="element-122">
              {step.icon}
            </div>
            <h3 className="text-xl font-bold text-charcoal mb-3 font-sans" data-id="element-123">
              {step.title}
            </h3>
            <p className="text-gray-600 leading-relaxed px-4" data-id="element-124">{step.desc}</p>
          </div>)}
      </div>
    </SectionWrapper>;
}